/**
 * Main Class and namespace
 * @class Proj
 * @singletone
 */
var Proj = (function() {
    var opt = {
        ajaxURI: '/json/'
    };

    var _loaderCount = 0,
        _sessionId = '';

    if (window.location.toString().match(/SESS_ID=(\d+)/)) {
        _sessionId = RegExp.$1;
    }

    $(document).ajaxStart(showLoader).ajaxStop(hideLoader).ajaxError(function(event, XMLHttpRequest, ajaxOptions, thrownError) {
        alert('Произошла ошибка при загрузке данных. Попробуйте перезагрузить страницу');
    });

    $.ajaxSettings.traditional = true;
    $.extend($.fancybox.defaults, {
        padding: 24
    });

    function showLoader() {
        $(document.body).addClass('is-loading');
        _loaderCount ++;
    }

    function hideLoader() {
        _loaderCount --;
        if (_loaderCount === 0) {
            $(document.body).removeClass('is-loading');
        }
    }

    function init() {
        $("form").on('submit', function(e) {
            var $form = $(this);
            if ($form.data('goal')) {
                try {
                    yaCounter20207536.reachGoal($form.data('goal'));
                } catch (err) {
                    console.error(err);
                }
            }
            return true;
        });

        $(".js-slider").each(function(i) {
            var $items = $(".js-slider-item", this),
                $bgPrev = $(".js-slider-bg-prev"),
                $bgNext = $(".js-slider-bg-next");
            $items.slider({
                goOutCssBefore: function(prevIdx, nextIdx, itemCount) { return { left: '0%' } },
                goOutCssAfter: function(prevIdx, nextIdx, itemCount) { return { left: (prevIdx > nextIdx) ? '-100%' : '100%' } },
                goInCssBefore: function(prevIdx, nextIdx, itemCount) { return { left: (prevIdx > nextIdx) ? '100%' : '-100%' } },
                goInCssAfter: function(prevIdx, nextIdx, itemCount) { return { left: '0%' } },
                beforeChange: function(prevIdx, nextIdx, itemCount) {
                    var src = $items.eq(nextIdx).data('src');
                    $bgPrev.fadeOut(300);
                    $bgNext.css({ backgroundImage: "url('"+src+"')" }).fadeIn(300);
                },
                afterChange: function(prevIdx, nextIdx, itemCount) {
                    var src = $items.eq(nextIdx).data('src');
                    $bgPrev.css({ backgroundImage: "url('"+src+"')" }).show();
                    $bgNext.css({ backgroundImage: '' }).hide();
                },
                duration: 300,
                autoChange: true,
                delay: 4000,
                stopOnMouseOver: true,
                prev: $(".js-slider-prev", this),
                next: $(".js-slider-next", this),
                nav: $(".js-slider-nav", this)
            });
        });
        $(".js-scroller").each(function(i) {
            $(".js-scroller-item", this).scroller({
                prev: $(".js-scroller-prev", this),
                next: $(".js-scroller-next", this)
            });
        });


        $(".js-stickyScroll").each(function(i){
            
            $(".js-stickyScroll-item",this).stick_in_parent({
                 // Чтобы сразу прокручивался обратно
                    inner_scrolling: true,
                    // Отступ сверху
                    offset_top: 20,
                    recalc_every: 1
             });
        });

        $(".js-tabs").each(function(i) {
            var $links = $(".js-tabs-link", this),
                $items = $(".js-tabs-item", this);
            function show(idx) {
                $links.removeClass('is-active').eq(idx).addClass('is-active');
                $items.hide().eq(idx).show();
            }
            $links.on('click', function(e) {
                e.preventDefault();

                var idx = $links.index(this);
                show(idx);
            });
            $(".js-tabs-item-header", this).hide();
            show(0);
        });
        $(".js-rolls").each(function(i) {
            var $link = $(".js-rolls-link", this),
                $content = $(".js-rolls-content", this);
            $link.on('click', function(e) {
                e.preventDefault();

                if ($content.is(":visible")) {
                    $link.removeClass('is-active');
                    $content.slideUp();
                } else {
                    $link.addClass('is-active');
                    $content.slideDown();
                }
            });
            $content.hide();
        });
        $(".js-side-service").each(function(i) {
            var $block = $(this),
                $label = $(".js-side-service-label", this),
                $content = $(".js-side-service-content", this),
                $body = $(Browser.getScrollBody()),
                wasShown = false,
                timer = -1;

            $label.on('click', function(e) {
                e.preventDefault();

                if ($block.hasClass('is-opened')) {
                    hide();
                } else {
                    show();

                    try {
                        yaCounter20207536.reachGoal('consultation');
                    } catch (err) {
                        console.error(err);
                    }
                }
            });
            $content.on('click', function(e) {
                e.stopPropagation();
            });

            function show() {
                wasShown = true;
                $block.addClass('is-opened');
                $(document.documentElement).on('click', hide);
            }
            function hide() {
                $block.removeClass('is-opened');
                $(document.documentElement).off('click', hide);
            }

            var $main = $(".js-side-service-main");
            var windowHeight = 0,
                mainOffset = 0,
                mainHeight = 0,
                labelHeight = 0;

            function scroll(e) {
                var scrollTop = $body.prop('scrollTop');
                var offset = scrollTop + windowHeight - mainOffset;

                if (offset > mainOffset + mainHeight - labelHeight) {
                    offset = mainOffset + mainHeight - labelHeight;
                }

                $block.css({ top: offset - labelHeight });
            }
            function resize(e) {
                windowHeight = $(window).height(),
                mainOffset = $main.offset().top;
                mainHeight = $main.outerHeight();
                labelHeight = $label.outerHeight();

                scroll();
            }

            $(window).on('resize', resize);
            $(window).on('scroll', scroll);

            resize();
        });


        $(".js-fancybox, a[rel='lightbox']").fancybox();

/*
        var $asideLinks = $(".js-aside-item"),
            $asideBlocks = $(".js-aside-block");
        $asideLinks.on('mouseover', function(e) {
            var $link = $(this);
            var node = $link.data('node');
            var $block = $asideBlocks.filter("[data-node='"+node+"']")

            $link.data('hover', true);

            setTimeout(function() {
                if ($link.data('hover') || $block.data('hover')) {
                    $block.stop(true).animate({ width: 'show' });
                }
            }, 100);
        }).on('mouseout', function(e) {
            var $link = $(this);
            var node = $link.data('node');
            var $block = $asideBlocks.filter("[data-node='"+node+"']")

            $link.data('hover', false);

            setTimeout(function() {
                if (!$link.data('hover') && !$block.data('hover')) {
                    $block.stop(true).animate({ width: 'hide' });
                }
            }, 100);
        });
        $asideBlocks.on('mouseover', function(e) {
            var $block = $(this);
            var node = $block.data('node');
            var $link = $asideLinks.filter("[data-node='"+node+"']");

            $block.data('hover', true);

            setTimeout(function() {
                if ($block.data('hover') || $link.data('hover')) {
                    $block.stop(true).animate({ width: 'show' });
                }
            }, 100);
        }).on('mouseout', function(e) {
            var $block = $(this);
            var node = $block.data('node');
            var $link = $asideLinks.filter("[data-node='"+node+"']");

            $block.data('hover', false);

            setTimeout(function() {
                if (!$block.data('hover') && !$link.data('hover')) {
                    $block.stop(true).animate({ width: 'hide' });
                }
            }, 100);
        });
*/

        $(".js-ajax-form-link").on('click', function(e) {
            e.preventDefault();

            function submit(el) {
                var $form = $(el);
                if (!$form.is("form")) {
                    $form = $form.find("form");
                }

                if (!$form.length) return;

                if ($form.data('goal')) {
                    try {
                        yaCounter20207536.reachGoal($form.data('goal'));
                    } catch (err) {
                        console.error(err);
                    }
                }

                var $fields = $form.find(".js-form-field");
                $fields.filter(".is-error").removeClass("is-error");

                var params = $form.serialize();

                getJSON('send_form', params, function(data) {
                    if (data.ok) {
                        $form.html(data.html);
                    } else if (data.errors) {
                        for (var p in data.errors) {
                            $fields.filter(".m--name-"+p).addClass("is-error");
                        }
                    }
                });
            }

            var params = $.extend({}, { href: this.href.replace(/^\w+:\/\/[^\/]+/, "") }, $(this).data());
            getJSON('get_form', params, function(data) {
                $.fancybox({
                    type: 'html',
                    content: data.html,
                    afterShow: function() {
                        var $form = this.inner.find("form");
                        $form.on('submit', function(e) {
                            e.preventDefault();
                            submit(this);
                        }).find('input:file').fileupload();
                    }
                });
            });
        });

        $(".js-subscribe-form").each(function(i) {
            var $action = $("input[name='_action']", this),
                $nameField = $(".js-form-field.m--name-name", this),
                $nameInput = $("input[name='name']", this);

            function actionChangeHandler(e) {
                var value = $action.filter(":checked").val();

                if (value === 'subscribe') {
                    $nameField.show();
                    $nameInput.prop('disabled', false);
                } else {
                    $nameField.hide();
                    $nameInput.prop('disabled', true);
                }
            }

            function formSubmitHandler(e) {
                var value = $action.filter(":checked").val();
                if (value === 'subscribe') {
                    try {
                        yaCounter20207536.reachGoal('newsletter');
                    } catch (err) {
                        console.error(err);
                    }
                }

                return true;
            }

            $(this).on('submit', formSubmitHandler);
            $action.on('change', actionChangeHandler);
            actionChangeHandler();
        });

        $(".js-report-item").each(function(e) {
            var $item = $(this),
                $block = $item.find('.js-report-block'),
                $content = $item.find('.js-report-content'),
                $open = $item.find('.js-report-open'),
                $close = $item.find('.js-report-close');

            var blockMinHeight = $block.data('height'),
                blockHeight,
                contentMinHeight = $content.data('height'),
                contentHeight,
                isToggle = false;

            function resize() {
                blockHeight = $block.get(0).scrollHeight;
                contentHeight = $content.get(0).scrollHeight;
                if (contentHeight > contentMinHeight) {
                    $block.css({
                        maxHeight: blockMinHeight
                    });
                    $content.css({
                        maxHeight: contentMinHeight
                    });
                    $open.show()
                    $close.hide();
                    isToggle = false;
                } else {
                    $block.css({
                        maxHeight: ''
                    });
                    $content.css({
                        maxHeight: ''
                    });
                    $open.hide();
                    $close.hide();
                }
            }

            $open.click(function() {
                if (isToggle == false) {
                    $block.css({
                        maxHeight: '100%'
                    });
                    $content.css({
                        maxHeight: '100%'
                    });
                    isToggle = true;
                    $open.hide();
                    $close.show();
                }
            });

            $close.click(function() {
                if (isToggle == true) {
                    $block.css({
                        maxHeight: blockMinHeight
                    });
                    $content.css({
                        maxHeight: contentMinHeight
                    });
                    isToggle = false;
                    $open.show();
                    $close.hide();
                }
            });

            $(window).resize(resize);
            resize();
        });
        $(".js-toggleinfo-item").each(function(e) {
            var $item = $(this),
                $block = $item.find('.js-toggleinfo-block'),
                $content = $item.find('.js-toggleinfo-content'),
                $open = $item.find('.js-toggleinfo-open'),
                $close = $item.find('.js-toggleinfo-close');

            var blockMinHeight = $block.data('height'),
                blockHeight,
                contentMinHeight = $content.data('height'),
                contentHeight,
                isToggle = false;

            function resize() {
                blockHeight = $block.get(0).scrollHeight;
                contentHeight = $content.get(0).scrollHeight;
                if (contentHeight > contentMinHeight) {
                    $block.css({
                        maxHeight: blockMinHeight
                    });
                    $content.css({
                        maxHeight: contentMinHeight
                    });
                    $open.show()
                    $close.hide();
                    isToggle = false;
                } else {
                    $block.css({
                        maxHeight: ''
                    });
                    $content.css({
                        maxHeight: ''
                    });
                    $open.hide();
                    $close.hide();
                }
            }

            $open.click(function() {
                if (isToggle == false) {
                    $block.css({
                        maxHeight: '100%'
                    });
                    $content.css({
                        maxHeight: '100%'
                    });
                    isToggle = true;
                    $open.hide();
                    $close.show();
                }
            });

            $close.click(function() {
                if (isToggle == true) {
                    $block.css({
                        maxHeight: blockMinHeight
                    });
                    $content.css({
                        maxHeight: contentMinHeight
                    });
                    isToggle = false;
                    $open.show();
                    $close.hide();
                }
            });

            $(window).resize(resize);
            resize();
        });
        $(".js-contact-map").each(function(e) {
            var $map = $(this),
                $main = $(".js-contact-main"),
                $label = $(".js-contact-label"),
                $body = $(Browser.getScrollBody());

            var windowHeight,
                mainOffset,
                mainHeight;

            function scroll(e) {
                var scrollTop = $body.prop('scrollTop');

                var offset = scrollTop - mainOffset;
                if (offset > mainHeight - windowHeight) {
                    offset = mainHeight - windowHeight;
                }

                if (offset > 0) {
                    $map.css({ top: offset });
                } else {
                    $map.css({ top: '' });
                }
            }
            function resize(e) {
                mainOffset = $main.offset().top;
                mainHeight = $main.outerHeight();
                windowHeight = $(document.documentElement).prop('clientHeight');

                $map.css({ height: windowHeight });
                scroll();
            }

            $(window).on('resize', resize).on('scroll', scroll);
            resize();

            $label.on('click', function(e) {
                e.preventDefault();

                if ($main.hasClass("m--hidden")) {
                    $main.removeClass("m--hidden");
                    $label.text($label.data('showText'));
                } else {
                    $main.addClass("m--hidden");
                    $label.text($label.data('hideText'));
                }
            });
        });

        if ( $('.js-info').length ) {
            $('.t-calc__char-info').toggle();

            $('.js-info').on('click', function(e) {
                var $this = $(this),
                    $thisInfo = $this.find(".t-calc__char-info");

                var opened_pads = $(".js-info.active");

                $.each(opened_pads, function(){
                    if (!$(this).is($this) && $(this).has(e.target).length === 0) {
                        $thisInfo.hide();
                        $this.removeClass('active');
                    }
                });

                if ($thisInfo.css('display') === 'none') {
                    $thisInfo.show();
                    $this.addClass('active');
                } else {
                    $thisInfo.hide();
                    $this.removeClass('active');
                }

                e.stopPropagation();
            });

            $(document).click(function(e){
                $(".js-info").removeClass('active');
                $(".t-calc__char-info").hide();
            });
        }

        $(document.body).on('click', ".js-goal-link", function(e) {
            var $el = $(this);
            var goal = $el.data('goal');
            if (goal) {
                console.log('reachGoal', goal);
                try {
                    yaCounter20207536.reachGoal(goal);
                } catch (error) {
                    console.error(error);
                }
                /*
                try {
                    ga('send', 'event', goal);
                } catch (error) {
                    console.error(error);
                }
                */
            }
        });
        $(document.body).on('submit', ".js-goal-form", function(e) {
            var $el = $(this);
            var goal = $el.data('goal');
            if (goal) {
                console.log('reachGoal', goal);
                try {
                    yaCounter20207536.reachGoal(goal);
                } catch (error) {
                    console.error(error);
                }
                /*
                try {
                    ga('send', 'event', goal);
                } catch (error) {
                    console.error(error);
                }
                */
            }
        });

        var $scrollBody = $(Browser.getScrollBody()),
            $scrollAside = $(".js-aside");
        var asideOnHorizontal = false,
            asideOnVertical = false,
            bodyScrollWidth = 0,
            bodyClientWidth = 0,
            bodyHeight = 0,
            scrollTop = 0,
            asideHeight = 0,
            scrollDown = true,
            offsetTop = 0,
            positionTop = 0;

        function asideCheckVertical(e) {
            if (scrollDown) {
                var offset = asideHeight - bodyHeight;
                var delta = scrollTop - positionTop;

                if (delta < offset) {
                    offsetTop = delta;
                } else {
                    offsetTop = offset;
                }
            } else {
                var offset = asideHeight - bodyHeight;
                var delta = positionTop - scrollTop;

                if (delta < offset) {
                    offsetTop = offset - delta;
                } else {
                    offsetTop = 0;
                }
            }
            $scrollAside.css({ top: -offsetTop });
        }
        function asideScrollVertical(e) {
            var newScrollTop = $scrollBody.prop('scrollTop');
            if (newScrollTop > scrollTop) {
                if (!scrollDown) {
                    scrollDown = true;
                    positionTop = newScrollTop;

                    if (offsetTop) {
                        positionTop -= offsetTop;
                    }
                }
            } else {
                if (scrollDown) {
                    scrollDown = false;
                    positionTop = newScrollTop;

                    var offsetBottom = asideHeight - bodyHeight - offsetTop;
                    if (offsetBottom) {
                        positionTop += offsetBottom;
                    }
                }
            }
            scrollTop = newScrollTop;
            asideCheckVertical(e);
        }
        function asideScrollHorizontal(e) {
            var newScrollLeft = $scrollBody.prop('scrollLeft');
            $scrollAside.css({ left: -newScrollLeft });
        }
        function asideResize(e) {
            bodyScrollWidth = $(document.documentElement).prop('scrollWidth');
            bodyClientWidth = $(document.documentElement).prop('clientWidth');

            bodyHeight = $(document.documentElement).prop('clientHeight');
            asideHeight = $scrollAside.outerHeight();

            if (asideHeight > bodyHeight) {
                if (!asideOnVertical) {
                    $(window).on('scroll', asideScrollVertical);
                    asideCheckVertical(e);
                    asideOnVertical = true;
                }
            } else {
                if (asideOnVertical) {
                    $(window).off('scroll', asideScrollVertical);
                    $scrollAside.css({ top: 0 });
                    asideOnVertical = false;
                }
            }

            if (bodyScrollWidth > bodyClientWidth) {
                if (!asideOnHorizontal) {
                    $(window).on('scroll', asideScrollHorizontal);
                    asideOnHorizontal = true;
                }
            } else {
                if (asideOnHorizontal) {
                    $(window).on('scroll', asideScrollHorizontal);
                    $scrollAside.css({ left: 0 });
                    asideOnHorizontal = false;
                }
            }

            if ( $(window).width() > 1800 ) {
                // $('#res').addClass('absolute');
                // $('.side-service').toggleClass('service-absolute');
            } else {
                // $('#res').removeClass('absolute');
                // $('.side-service').toggleClass('service-absolute');
            }

        }

        $(window).on('resize', asideResize);
        asideResize();
    }

    function getJSON(act, data, handler) {
        if (_sessionId) {
            if (data instanceof Array) {
                data.push({ name: 'SESS_ID', value: Proj.SESS_ID });
            } else if (typeof data === 'object') {
                data.SESS_ID = Proj.SESS_ID;
            } else {
                if (data != '') data += '&';
                data += 'SESS_ID='+Proj.SESS_ID;
            }
        }
        if (!/^\//.test(act)) {
            act = opt.ajaxURI+act;
        }
        if (!/\/$/.test(act)) {
            act += '/';
        }
        $.post(act, data, handler, 'json');
    }

    return {
        SESS_ID : _sessionId,
        init: init,
        getJSON: getJSON
    };


})();


